import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { CategoryForm } from 'features/cris/categories/category-form';
import { CategorySearch } from 'features/cris/categories/category-search';

export const CategoryRouter: React.FunctionComponent = () => (
    <Switch>
        <Route exact path='/cris/categories'>
            <CategorySearch />
        </Route>
        <Route exact path='/cris/categories/:id'>
            <CategoryForm />
        </Route>
    </Switch>
);
